import { render, staticRenderFns } from "./Licbar.vue?vue&type=template&id=b769f9e6&scoped=true&"
import script from "./Licbar.vue?vue&type=script&lang=js&"
export * from "./Licbar.vue?vue&type=script&lang=js&"
import style0 from "./Licbar.vue?vue&type=style&index=0&id=b769f9e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b769f9e6",
  null
  
)

export default component.exports